// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_i-0";
export var skeletonCard = "_i-1";